import { Component, OnInit, Output, EventEmitter, OnDestroy, Input, Inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { UserService } from '../../services/user.service';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { GeneralService } from '../../services/general.service';
import { AuthService } from '../../services/auth.service';
import { HomeMenus, MenuRuter } from '../../models/home-model/home.model';
import { RouteService } from '../../services/route.service';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatIcon,
    MatButtonModule,
    MatMenuModule,
    TranslateModule,
    MatTooltip,
    TranslateModule,
    MatIconModule,
  ],
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() titleDetail: any;
  @Output() public sidenavToggle = new EventEmitter();
  private lagnImage: string;
  private subscription!: Subscription;
  private appName: string = '';
  private showTitleHeader: boolean;
  private currentUrl: string | null = '';
  private urlsWithoutHeader: string[] = ['/home', '/workflow'];
  public currentSection: string = '';
  public name: string | null = '';
  public menuCarvesrt!: RouteService['menuCarvesrt'];
  public menu: MenuRuter[] = [];
  public title: string = '';
  public isTab: boolean = false;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private userService: UserService,
    private authService: AuthService,
    private generalService: GeneralService,
    @Inject(RouteService) private routeService: RouteService,
  ) {
    this.lagnImage = 'assets/images/icon-cambiar-espaniol.svg';
    this.showTitleHeader = false;
    this.menuCarvesrt = this.routeService.menuCarvesrt;

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects.toLowerCase();

        if (url.includes('active-portfolio')) {
          this.currentSection = 'CARTERA ACTIVA';
        } else if (url.includes('dealers')) {
          this.currentSection = 'DISTRIBUIDORES';
        } else if (url.includes('users')) {
          this.currentSection = 'USUARIOS';
        } else if (url.includes('suppliers')) {
          this.currentSection = 'PROVEEDORES';
        } else if (url.includes('notifications')) {
          this.currentSection = 'NOTIFICACIONES';
        } else if (url.includes('plans')) {
          this.currentSection = 'PLANES';
        } else if (url.includes('brands')) {
          this.currentSection = 'MARCAS';
        } else if (url.includes('programs')) {
          this.currentSection = 'PROGRAMAS';
        } else if (url.includes('insurances')) {
          this.currentSection = 'ASEGURADORAS';
        } else if (url.includes('deadlines')) {
          this.currentSection = 'PLAZOS';
        } else if (url.includes('configuration')) {
          this.currentSection = 'CONFIGURACIÓN';
        } else if (url.includes('workflow')) {
          this.currentSection = 'WORKFLOW';
        } else if (url.includes('quotation')) {
          this.currentSection = 'COTIZADOR';
        } else if (url.includes('lease-line')) {
          this.currentSection = 'LINEA DE ARRENDAMIENTO';
        } else if (url.includes('maintenance')) {
          this.currentSection = 'MANTENIMIENTO';
        } else if (url.includes('reportes')) {
          this.currentSection = 'REPORTES';
        } else if (url.includes('boards')) {
          this.currentSection = 'TABLEROS';
        } else if (url.includes('expired-portfolio')) {
          this.currentSection = 'CARTERA VENCIDA';
        } else if (url.includes('additional')) {
          this.currentSection = 'Adicionales';
        } else if (url.includes('user-types')) {
          this.currentSection = 'TIPOS DE USUARIO';
        } else if (url.includes('tasks-list')) {
          this.currentSection = 'LISTA DE TAREAS';
        } else if (url.includes('products')) {
          this.currentSection = 'PRODUCTOS';
        } else if (url.includes('person-types')) {
          this.currentSection = 'TIPOS DE PERSONA';
        } else {
          this.currentSection = '';
        }
      }
    });
  }

  ngOnInit() {
    this.appName = environment.appName;
    this.currentUrl = this.router.url;
    if (this.urlsWithoutHeader.find((x) => x == this.currentUrl) == null) {
      this.showTitleHeader = true;
    }
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
    this.name = localStorage.getItem('firstName');
  }

  public onToggleSidenav = () => {
    this.sidenavToggle.emit();
  };

  changeLang() {
    const currentLang = this.translate.defaultLang;
    if (currentLang === 'es') {
      localStorage.setItem('lang', 'en');
      this.translate.setDefaultLang('en');
      this.lagnImage = 'assets/images/icon-cambiar-ingles.svg';
    } else {
      localStorage.setItem('lang', 'es');
      this.translate.setDefaultLang('es');
      this.lagnImage = 'assets/images/icon-cambiar-espaniol.svg';
    }
  }

  logout() {
    this.authService.logout();
  }

  InboxNotifications() {
    this.router.navigate(['/notification/inbox']);
  }

  getClassByMenu(menu: any) {
    if (menu.route == this.router.url) {
      return 'mat-button active-menu';
    }
    return 'mat-button';
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }

  public navigateMenu(menu: MenuRuter, indexSelected: number, isTab: boolean): void {
    if (isTab) {
      this.goToUrl([menu.url ?? ''], { indexSelected });
    } else {
      this.router.navigate([menu.url]);
    }
  }

  public goToUrl(route: string[], queryParams: { [key: string]: string | number }) {
    this.generalService.goToUrl(route, queryParams, true);
  }
}
